import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { api, mcpUrl } from "../lib/api.ts";
import { useT } from "../lib/i18n.ts";
import { Ic } from "../components/Icons.tsx";
import { Toast, useToast } from "../components/Ui.tsx";

/**
 * The Instead connector (D-23/D-26): the AI check-in happens in the user's
 * OWN assistant via MCP. Connecting there IS the consent; this screen hands
 * over the address, shows the state, and can cut access from this side.
 */
export function Connect() {
  const t = useT();
  const qc = useQueryClient();
  const nav = useNavigate();
  const { data: ai } = useQuery({ queryKey: ["ai"], queryFn: api.ai.status });
  const [toast, say] = useToast();
  const url = mcpUrl();

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      say(t("copied"));
    } catch {
      // clipboard unavailable (older browsers) — the field is selectable
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--sp-4)" }}>
      <div className="screen-head" style={{ marginBottom: 0 }}>
        <button type="button" className="icon-btn" aria-label={t("back")} onClick={() => nav({ to: "/settings/services" })}>{Ic.back()}</button>
        <h1 className="title">{t("connect.title")}</h1>
      </div>

      <div className="banner" role="status" style={ai?.connected ? { background: "var(--accent-soft)", color: "var(--accent-ink)", fontWeight: 600 } : {}}>
        {ai?.connected && Ic.check({ size: 14 })}
        <span>{ai?.connected ? t("connect.connected") : t("connect.notConnected")}</span>
        {ai?.connected && (
          <button type="button" className="icon-btn danger" style={{ minHeight: 32 }} onClick={async () => { await api.ai.disconnect(); await qc.invalidateQueries({ queryKey: ["ai"] }); }}>
            {t("connect.disconnect")}
          </button>
        )}
      </div>

      <p className="meta">{t("connect.consent")}</p>

      <div>
        <div className="eyebrow">{t("connect.urlLabel")}</div>
        <div className="addr">
          <code aria-label={t("connect.urlLabel")}>{url}</code>
          <button type="button" className="icon-btn accent" aria-label={t("connect.copy")} title={t("connect.copy")} onClick={copy}>{Ic.copy({ size: 16 })}</button>
        </div>
      </div>

      <div className="card" style={{ padding: "var(--sp-3) var(--sp-4)" }}>
        <p className="meta" style={{ color: "var(--ink)" }}>{t("connect.steps")}</p>
      </div>
      <Toast msg={toast} />
    </div>
  );
}
